// Only the configured API may receive the current bearer token.
export const resolveRecordingUrl = (pathRecord, apiUrl, pageUrl) => {
  if (typeof pathRecord !== "string" || !pathRecord.trim()) throw new Error("Enregistrement absent");
  const api = new URL(apiUrl, pageUrl);
  if (!/^https?:$/.test(api.protocol) || api.username || api.password) throw new Error("API audio invalide");
  const raw = pathRecord.trim();
  if (raw.startsWith("//")) throw new Error("Origine audio non autorisée");
  const url = new URL(raw.startsWith("/files/") ? raw : raw.replace(/^\/+/, ""), new URL("/files/", api));
  if (url.origin !== api.origin || !url.pathname.startsWith("/files/") ||
      url.username || url.password || url.search || url.hash) throw new Error("URL audio non autorisée");
  return url.href;
};

export const fetchRecordingBlob = async (pathRecord, { apiUrl, pageUrl, authorization, signal, fetchImpl = fetch }) => {
  const url = resolveRecordingUrl(pathRecord, apiUrl, pageUrl);
  if (!authorization || !/^Bearer \S+$/.test(authorization)) throw new Error("Authentification audio requise");
  const response = await fetchImpl(url, {
    headers: { Authorization: authorization }, signal,
    credentials: "omit", redirect: "error",
  });
  if (!response.ok) throw new Error("Lecture audio impossible (HTTP " + response.status + ")");
  const blob = await response.blob();
  if (!blob.size) throw new Error("Enregistrement vide");
  return blob;
};

export const formatAudioExportDate = (value) =>
  value ? new Date(value).toISOString().slice(0, 19).replace(/[:T]/g, "-") + "_UTC" : "date-inconnue";
